<div class="selection-bar" #selectionBar>
  <div class="container p-3">
    <div class="row">
      <div class="align-items-center col-12 col-md-auto d-flex selection">
        <div class="d-flex">
          <span translate>SELECTED_ITEM_COUNT</span>:
          <div id="items-selected">{{ selection.selectedItemCount }}</div>
        </div>
        <button class="btn btn-outline-secondary ml-4 mobile-btn" (click)="toggleSelectedItems()">
          <span translate *ngIf="selectedToggle">SHOW_ALL_ITEMS</span>
          <span translate *ngIf="!selectedToggle">SHOW_SELECTED_ITEMS</span>
        </button>
      </div>
      <div class="col d-flex justify-content-end flex-md-wrap selection-actions">
        <div ngbDropdown placement="top-right" class="d-inline-block dropup" *ngIf="filteredItems">
          <button
            class="btn btn-primary export-area-buttons mobile-btn"
            id="dropdownSelection"
            ngbDropdownToggle
            translate
          >
            SELECTION_ALTERNATIVES
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="dropdownSelection"
            class="dropdown-container dropdown-container-max-height"
          >
            <button class="export-area-buttons mobile-btn" ngbDropdownItem (click)="selectAllFilteredItems()">
              <span translate *ngIf="filteredItems?.length !== allItems?.length">SELECT_ALL_FILTERED_ITEMS</span>
              <span translate *ngIf="filteredItems?.length === allItems?.length">SELECT_ALL_ITEMS</span>
            </button>
            <button
              class="export-area-buttons mobile-btn"
              ngbDropdownItem
              (click)="deselectAllFilteredItems()"
              translate
            >
              DESELECT_ALL_FILTERED_ITEMS
            </button>
            <button class="export-area-buttons mobile-btn" ngbDropdownItem (click)="clearSelection()" translate>
              DESELECT_ALL_ITEMS
            </button>
            <button
              class="export-area-buttons mobile-btn"
              ngbDropdownItem
              *ngFor="let button of getSelectionMarkingActions()"
              (click)="button.performAction(selection)"
              translate
            >
              {{ button.label }}
            </button>
          </div>
        </div>
        <div ngbDropdown placement="top-right" class="d-inline-block dropup actions" autoClose="outside" #actionsDropdown="ngbDropdown" (openChange)="onDropdownOpenChange($event)">
          <button
            class="btn btn-outline-primary export-area-buttons mobile-btn"
            id="dropdownBasic1"
            ngbDropdownToggle
            translate
          >
            {{ actionButtonTitle }}
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="dropdownBasic1"
            class="dropdown-container dropdown-container-max-height"
          >
            <button
              class="export-area-buttons mobile-btn"
              ngbDropdownItem
              *ngFor="let button of actions"
              (click)="performActionAndClose(button)"
              translate
            >
              {{ button.label }}
            </button>
            <div class="dropdown-divider" *ngIf="actions.length > 0 && actionGroups.length > 0"></div>
            <ng-container *ngFor="let group of actionGroups">
              <button
                class="export-area-buttons mobile-btn group-header"
                ngbDropdownItem
                (click)="group.isOpen = !group.isOpen; $event.stopPropagation()"
              >
                <span>{{ group.groupName | translate }}</span>
                <i class="fa" [class.fa-chevron-right]="!group.isOpen" [class.fa-chevron-down]="group.isOpen"></i>
              </button>
              <div class="group-items" [class.open]="group.isOpen">
                <div>
                  <button
                    class="export-area-buttons mobile-btn"
                    ngbDropdownItem
                    *ngFor="let action of group.actions"
                    (click)="performActionAndClose(action)"
                    translate
                  >
                    {{ action.label }}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
